// extracted by mini-css-extract-plugin
export default {"button":"styles_button__y+l1g","icon":"styles_icon__-eFa6","label":"styles_label__VWWZG","disabled":"styles_disabled__nxa14"};